import { render } from "./bulk-customers-upload.vue?vue&type=template&id=5c51f1ba"
import script from "./bulk-customers-upload.vue?vue&type=script&lang=js"
export * from "./bulk-customers-upload.vue?vue&type=script&lang=js"

import "./bulk-customers-upload.vue?vue&type=style&index=0&id=5c51f1ba&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__